// React hook for dynamic mock data based on language
import { useTranslation } from 'react-i18next';
import * as mockEn from './mock-en';
import * as mockFr from './mock-fr';
import * as mockAr from './mock-ar';

const mocks = { en: mockEn, fr: mockFr, ar: mockAr };

export const useMockData = () => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];
  return mocks[lang] || mocks.en;
};

